export default __webpack_public_path__ + "static/media/SearchIcon.865e0ba7.svg";